import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import FormGroup from "@material-ui/core/FormGroup";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import CreateIngredients from "./CreateIngredients";
import EditIcon from "@material-ui/icons/Edit";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";

const CustomSwitch = withStyles({
	switchBase: {
		color: "#326dff",
		"&$checked": {
			color: "#326dff",
		},
		"&$checked + $track": {
			backgroundColor: "#326dff",
		},
	},
	checked: {},
	track: {},
})(Switch);

const Ingredients = ({
	data,
	createIngredients,
	deleteIngredient,
	updateIngredient,
	changeStatus,
}) => {
	const classes = useStyles();

	const [openModal, setOpenModal] = useState(false);
	const [isEdit, setIsEdit] = useState(false);
	const [selectItem, setSelectItem] = useState(null);

	const [selectId, setSelectId] = useState(null);
	const handleOpenModal = (index = null, item = null) => {
		if (item) {
			setIsEdit(true);
			setSelectId(index);
			setSelectItem(item);
		}
		setOpenModal(true);
	};

	const handleCloseModal = () => {
		// setSelectedLabel(null);
		setOpenModal(false);
		setIsEdit(false);
		setSelectId(null);
		setSelectItem(null);
	};

	const isData =
		Array.isArray(data) &&
		data.length > 0 &&
		data[0] &&
		Object.keys(data[0]).length > 0;

	return (
		<>
			<div className={classes.container}>
				<div className={classes.ingredientsHeaderWrap}>
					<Typography className={classes.typography} variant="h5">
						Ингредиенты
					</Typography>
					<Button
						className={classes.button}
						variant="contained"
						color="primary"
						onClick={() => handleOpenModal()}
					>
						Создать
					</Button>
				</div>
				{isData ? (
					data.map((ingr, index) => (
						<Grid item xs={12} key={index} className={classes.item}>
							<Typography className={classes.name}>{ingr.name.uk}</Typography>
							<FormGroup>
								<div className={classes.orderChange}>
									<EditIcon
										className={classes.editIcon}
										onClick={() => handleOpenModal(index, ingr)}
									/>
									<DeleteOutlineIcon
										className={classes.trashIcon}
										onClick={() => deleteIngredient(index)}
									/>
									<FormControlLabel
										control={
											<CustomSwitch
												checked={ingr.isActive}
												onChange={() => changeStatus(index)}
											/>
										}
										className={classes.switchLabel}
									/>
								</div>
							</FormGroup>
						</Grid>
					))
				) : (
					<Typography className={classes.noLabelsText}>
						Нет доступных ингредиентов
					</Typography>
				)}

				<CreateIngredients
					open={openModal}
					onClose={handleCloseModal}
					createIngredients={createIngredients}
					isEdit={isEdit}
					// onSave={handleSaveLabel}
					initialData={selectItem}
					updateIngredient={updateIngredient}
					selectId={selectId}
				/>
			</div>
		</>
	);
};

const useStyles = makeStyles((theme) => ({
	orderChange: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	button: {
		width: 140,
		height: 36,
		fontSize: "12px",
		uploadButton: {
			backgroundColor: theme.palette.primary.main,
			color: "white",
			"&:hover": {
				backgroundColor: theme.palette.primary.dark,
			},
		},
	},
	editIcon: {
		width: 22,
		height: 22,
		marginRight: 15,
		color: "#476282",
		"&:hover": {
			color: "#326dff",
			cursor: "pointer",
		},
	},
	trashIcon: {
		width: 22,
		height: 22,
		color: "#476282",
		"&:hover": {
			color: "#326dff",
			cursor: "pointer",
		},
	},
	ingredientsHeaderWrap: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		marginBottom: "10px",
	},
	container: {
		padding: theme.spacing(2),
		width: "100%",
		background: "#fff",
		padding: "30px 10px 30px",
	},
	item: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		marginBottom: theme.spacing(2),
		padding: theme.spacing(1),
		border: `1px solid ${theme.palette.divider}`,
		borderRadius: theme.shape.borderRadius,
	},
	name: {
		fontSize: 16,
		fontWeight: 500,
	},
	switchLabel: {
		marginLeft: theme.spacing(1),
	},
}));

export default Ingredients;
